/**
 * Authentication API endpoints
 */
import { apiClient } from '../client'

export interface LoginRequest {
  email: string
  password: string
}

export interface TokenResponse {
  access_token: string
  token_type: string
}

export interface UserResponse {
  id: number
  email: string
  full_name: string | null
  is_active: boolean
  is_superuser: boolean
  roles: Array<{ id: number; name: string }>
  organizations?: Array<{ id: number; name: string }> // Deprecated: Single-tenant mode, not used for filtering
}

export const authApi = {
  /**
   * Login user
   */
  async login(data: LoginRequest): Promise<TokenResponse> {
    const response = await apiClient.post<TokenResponse>('/api/v1/auth/login', data)
    return response.data
  },

  /**
   * Get current user info
   */
  async getCurrentUser(): Promise<UserResponse> {
    const response = await apiClient.get<UserResponse>('/api/v1/auth/me')
    return response.data
  },

  /**
   * Register new user (superuser only)
   * Single-tenant: organization_ids removed
   */
  async register(data: {
    email: string
    password: string
    full_name?: string
    is_active?: boolean
    role_ids?: number[]
  }): Promise<UserResponse> {
    const response = await apiClient.post<UserResponse>('/api/v1/auth/register', data)
    return response.data
  },
}

